import React from 'react';
import './SuccessModal.css';

const SuccessModal = ({ message, onClose, popupResponse }) => {
  const resData = popupResponse?.data;

  const isDuplicate = resData?.skipped_duplicates > 0;
  const isSuccess = resData?.processed > 0 && resData?.flashid;

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-container success" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <span className="close-btn" onClick={onClose}>&#10005;</span>
        </div>
        <div className="modal-body">
          <h2 className="modal-title">
            {isSuccess ? message || "Operation Successful!" : "Duplicate Entry Found"}
          </h2>

          {isSuccess && (
            <div className="popup-response">
              <p>
                <strong>FAID:</strong>{' '}
                <span className="response-value">{resData.flashid}</span>
              </p>
              <p>
                <strong>Status of the user:</strong>{' '}
                <span className="response-value">{popupResponse.status}</span>
              </p>
              <p>
                <em>
                  Please note down your unique Flashaid ID (FAID) for future reference.
                </em>
              </p>
            </div>
          )}

          {isDuplicate && (
            <div className="popup-response duplicate">
              <p>
                <strong>Message:</strong>{' '}
                <span className="response-value">{resData.message}</span>
              </p>
              <p>
                <strong>Duplicate Customer ID(s):</strong>{' '}
                <span className="response-value">
                  {resData.duplicate_customer_ids.join(", ")}
                </span>
              </p>
              <p>
                <em>
                  This entry already exists. Please use a different customer ID if you want to create a new record.
                </em>
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;
